// Application Configurations
import inspectionsApp from '../../Features/Inspections/inspectionsConfiguration';

const ownerOperatorApplications = [inspectionsApp];

export default ownerOperatorApplications;
